import React, { useState } from 'react';
import MethodSVGRender from './MethodSVGRender';
import { Modal } from '@mui/material';
import CreatePaymentModal from 'components/Plans/CreatePaymentModal';
import DeletePaymentModal from 'components/Billing/DeletePaymentModal';
import PaymentsAPI from 'api/PaymentsAPI';

interface IPayMethodsBox {
  methods: any;
  cusObj: any;
  cusId: string;
  setDefaultChanging: any;
  paymentSubmit?: string;
  setPaymentSubmit?: any;
}

const PayMethodsBox: React.FC<IPayMethodsBox> = (
  {
    methods,
    cusObj,
    cusId,
    setDefaultChanging,
    paymentSubmit,
    setPaymentSubmit
  }
) => {
  const [ createMode, setCreateMode ] = useState<boolean>(false);
  const [ deleteMode, setDeleteMode ] = useState<boolean>(false);
  const [ isExpanded, setIsExpanded ] = useState<boolean>(false);

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const changeDefaultPayment = async(cus_id: string, pay_id: string) => {
    setDefaultChanging(true);
    const update = await PaymentsAPI.changeDefaultPayment(cus_id, pay_id);
    if (update?.success) {
      setDefaultChanging(false);
      history.go(0);
    }
  };

  return (
    <div className='billing-ovw-payment-container'>
      <div className='billing-payment-text-group'>
        <div className='billing-payment-primary-text'>
          Payment methods
        </div>
        <div className='billing-payment-secondary-text'>
          Select your default payment method (this may vary by plan).
        </div>
      </div>
      {!methods.isLoading && methods.data?.data?.length === 0 ? (
        <>
          <div className='add-payment-method-btn' onClick={() => setCreateMode(true)}>
            + Add payment method
          </div>
          <Modal
            open={createMode}
            onClose={() => setCreateMode(false)}
          >
            <CreatePaymentModal
              cusId={cusId}
              setCreateMode={setCreateMode}
              paymentSubmit={paymentSubmit}
              setPaymentSubmit={setPaymentSubmit}
            />
          </Modal>
        </>
      ) : (
        <div className='billing-payment-default-card-container'>
          <div className='billing-payment-default-card-content'>
            {!methods.isLoading && (
              methods.data.data.map((method: any) => (
                <>
                  {method.id === cusObj.data.invoice_settings.default_payment_method && (
                    <>
                      <MethodSVGRender method={method} />
                      <div className='card-row-details-container'>
                        <div className='card-row-details-text-group'>
                          {!method.card && (
                            <div className='card-row-details-text-group-format'>
                              <div className='card-row-details-primary-text'>
                                Account ending in {method.us_bank_account?.last4 ? method.us_bank_account?.last4 : '****'}
                              </div>
                            </div>
                          )}
                          {method.card && (
                            <div className='card-row-details-text-group-format'>
                              <div className='card-row-details-primary-text'>
                                {method.card.brand.charAt(0).toUpperCase() + method.card.brand.slice(1)} ending in {method.card.last4}
                              </div>
                              {method.card.exp_month > 10 && (
                                <div className='card-row-details-secondary-text'>
                                  Expiry {method.card.exp_month}/{method.card.exp_year}
                                </div>
                              )}
                              {method.card.exp_month < 10 && (
                                <div className='card-row-details-secondary-text'>
                                  Expiry 0{method.card.exp_month}/{method.card.exp_year}
                                </div>
                              )}
                            </div>
                          )}
                          <div className='card-row-default-expand' onClick={handleExpand}>
                            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                              <path d='M7 15L12 20L17 15M7 9L12 4L17 9' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                            </svg>
                          </div>
                        </div>
                        <div className='card-row-details-action-group'>
                          <div className='card-row-action-btn'>
                            <div className='card-row-action-btn-text-default'>
                              Default
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ))
            )}
          </div>
        </div>
      )}
      {isExpanded && (
        <div className='billing-payment-extras-container'>
          {!methods.isLoading && (
            methods.data.data.map((method: any, index: number) => (
              <>
                {method.id !== cusObj.data.invoice_settings.default_payment_method && (
                  <div className='card-summary-row' key={index}>
                    <div className='card-row-content'>
                      <MethodSVGRender method={method} />
                      <div className='card-row-details-container'>
                        <div className='card-row-details-text-group'>
                          {!method.card && (
                            <div className='card-row-details-text-group-format'>
                              <div className='card-row-details-primary-text'>
                                Account ending in {method.us_bank_account?.last4 ? method.us_bank_account?.last4 : '****'}
                              </div>
                            </div>
                          )}
                          {method.card && (
                            <div className='card-row-details-text-group-format'>
                              <div className='card-row-details-primary-text'>
                                {method.card.brand.charAt(0).toUpperCase() + method.card.brand.slice(1)} ending in {method.card.last4}
                              </div>
                              {method.card.exp_month > 10 && (
                                <div className='card-row-details-secondary-text'>
                                  Expiry {method.card.exp_month}/{method.card.exp_year}
                                </div>
                              )}
                              {method.card.exp_month < 10 && (
                                <div className='card-row-details-secondary-text'>
                                  Expiry 0{method.card.exp_month}/{method.card.exp_year}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className='card-row-details-action-group'>
                          {method.id === cusObj.data.invoice_settings.default_payment_method ? (
                            <div className='card-row-action-btn'>
                              <div className='card-row-action-btn-text-default'>
                                Default
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className='card-row-action-btn' onClick={() => changeDefaultPayment(cusId, method.id)}>
                                <div className='card-row-action-btn-text'>
                                  Set as default
                                </div>
                              </div>
                              <div className='card-row-action-btn' onClick={() => setDeleteMode(true)}>
                                <div className='card-row-action-btn-text'>
                                  Delete
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <Modal
                      open={deleteMode}
                      onClose={() => setDeleteMode(false)}
                    >
                      <DeletePaymentModal pay_id={method.id} setDeleteMode={setDeleteMode} />
                    </Modal>
                  </div>
                )}
              </>
            ))
          )}
          <div className='add-payment-method-btn' onClick={() => setCreateMode(true)}>
            + Add payment method
          </div>
          <Modal
            open={createMode}
            onClose={() => setCreateMode(false)}
          >
            <CreatePaymentModal
              cusId={cusId}
              setCreateMode={setCreateMode}
              paymentSubmit={paymentSubmit}
              setPaymentSubmit={setPaymentSubmit}
            />
          </Modal>
        </div>
      )}
    </div>
  );
};

export default PayMethodsBox;
